import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {_TopNav} from './_TopNav.scss';
import ShoppingCart from './ShoppingCart.jsx';
import PostDemand from './PostDemand.jsx';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {logout} from 'base/actions';
import {ShowIf} from 'components/utils';
import {TopNavMenu} from './TopNavConfig.jsx';

class TopNav extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.dispatch(logout()).then(res => {
      toastr.success("Thành công", "Bạn đã đăng xuất thành công");
      this.props.history.push('/');
    });
  }

  render() {
    return (
      <div className='top-nav'>
        <div className='center'>
          <span className='btn-post-demand-show-mobile post-demand'><PostDemand/></span>
          <span className='btn-post-demand-show-mobile'><ShoppingCart/></span>
          {TopNavMenu.length > 0
            ? (TopNavMenu.map((item, i) => {
              return (
                <ul className={'user-nav-list ' + `${item.hasSubmenu
                  ? 'has-submenu'
                  : ''}`} key={i}>
                  <li className={'nav-item ' + `${item.isActive == this.props.isActive
                    ? 'is-active'
                    : ''}`}>
                    <ShowIf condition={item.link != null}>
                      <Link className='item-link' to={item.link}>{item.name}</Link>
                    </ShowIf>
                    <ShowIf condition={item.link == null}>
                      <span className='item-link'>{item.name}</span>
                    </ShowIf>
                  </li>
                  <ShowIf condition={this.props.auth.isAuthenticated && item.subAuthen.length > 0}>
                    <ul className='user-sub-list'>
                      {item.subAuthen.map((subAuthen, j) => {
                        return (
                          <li className={'sub-item ' + `${subAuthen.isActive == this.props.isActive
                            ? 'is-active'
                            : ''}`} key={j}>
                            <Link className='item-link' to={subAuthen.link}>{subAuthen.name}</Link>
                          </li>
                        )
                      })
}
                    </ul>
                  </ShowIf>
                  <ShowIf condition={!this.props.auth.isAuthenticated && item.subUnAuthen.length > 0}>
                    <ul className='user-sub-list'>
                      {item.subUnAuthen.map((subUnAuthen, j) => {
                        return (
                          <li className={'sub-item ' + `${subUnAuthen.isActive == this.props.isActive
                            ? 'is-active'
                            : ''}`} key={j}>
                            <Link className='item-link' to={subUnAuthen.link}>{subUnAuthen.name}</Link>
                          </li>
                        )
                      })
}
                    </ul>
                  </ShowIf>
                </ul>
              )
            }))
            : null
}
        </div>
      </div>
    )
  }
}

TopNav.defaultProps = {
  isActive: ''
};

const bindStateToProps = (state) => {
  return {auth: state.auth};
};

export default withRouter(connect(bindStateToProps)(TopNav));



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/TopNav.jsx